































































import { computed, defineComponent, PropType, ref } from "@vue/composition-api";
import { PayeeInformation, TaxFormType } from "@scrile/api-provider/dist/api/PayeeInformationProvider";
import { StepData } from "@/types";
import BaseButton from "@/components/BaseButton";
import BaseStepper from "@/components/BaseStepper";
import ModalView from "@/components/ModalView";
import PageTitle from "@/components/PageTitle";
import PayoutForm from "@/components/PayoutForm";
import PayeeTaxForm from "../PayeeTaxForm";
import ResidenceForm from "../ResidenceForm";

export default defineComponent({
  name: "PayoutPayeeInfoModal",
  components: { PayeeTaxForm, ResidenceForm, BaseButton, PageTitle, PayoutForm, BaseStepper, ModalView },
  props: {
    payeeInfo: { type: Object as PropType<PayeeInformation>, required: true },
  },
  setup(props, { emit }) {
    const loading = ref(false);
    const processing = ref(false);
    const valid = ref(false);
    const currentStep = ref(1);
    const taxFormType = ref<TaxFormType | null>(null);

    const submits: Record<string, () => Promise<any>> = {};
    const isPayeeInfoCompleted = computed(() => !!props.payeeInfo.payoutSystem);

    const steps = computed<Record<string, StepData>>(() => {
      return {
        ...(!isPayeeInfoCompleted.value
          ? {
              payeeInfo: {
                step: 1,
              },
            }
          : {}),
        residentialStatus: {
          step: isPayeeInfoCompleted.value ? 1 : 2,
        },
        taxForm: {
          step: isPayeeInfoCompleted.value ? 2 : 3,
        },
      };
    });

    const stepsCount = computed(() => {
      return Math.max(...Object.values(steps.value).map(i => i.step));
    });

    const getCurrentStep = (step: number) => {
      return "step-" + step;
    };

    const setCb = (stepName: string, cb: () => Promise<any>) => {
      submits[stepName] = cb;
    };

    const handleTitleClick = () => {
      if (currentStep.value === 1) {
        emit("close");
      } else {
        return currentStep.value--;
      }
    };

    const saveData = async () => {
      const keys = Object.keys(submits);
      for (const key of keys) {
        await submits[key]();
      }
    };

    const handleButtonClick = async (hasNext: boolean) => {
      if (hasNext) {
        currentStep.value = currentStep.value + 1;
      } else {
        try {
          processing.value = true;
          await saveData();
          emit("allowPayout", true);
        } finally {
          processing.value = false;
        }
      }
    };

    return {
      loading,
      processing,
      valid,
      currentStep,
      steps,
      taxFormType,
      isPayeeInfoCompleted,
      stepsCount,
      getCurrentStep,
      handleTitleClick,
      setCb,
      handleButtonClick,
    };
  },
});
